// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FSRw","label":"styles_label__1SBEI"};